export const SEARCH_PARAM_KEY_CALLBACK_URL = 'callbackUrl';

export const SEARCH_PARAM_KEY_BRANCH_ID = 'branchId';

export const SEARCH_PARAM_KEY_PAGINATION = 'pagination';
export const SEARCH_PARAM_KEY_FILTERS = 'filters';
export const SEARCH_PARAM_KEY_SORTER = 'sorter';

export const SEARCH_PARAM_KEY_DRAWER = 'drawer';

/**
 * 한 페이지에 성격이 다른 Drawer가 둘 이상 공존할 때 사용하는 보조 Drawer 키.
 * (예: 공용공간 예약 달력은 예약 상세 Drawer[drawer]와 공용공간 상세 Drawer[space-drawer]를 함께 띄운다.)
 * 같은 키에 서로 다른 스키마의 usePMSDrawer 훅이 붙으면 nuqs 크로스-훅 동기화로 상태가 오염되므로 키를 분리한다.
 */
export const SEARCH_PARAM_KEY_SPACE_DRAWER = 'space-drawer';

export const SEARCH_PARAM_KEY_DRAWER_PAGINATION = 'drawer-pagination';
export const SEARCH_PARAM_KEY_DRAWER_FILTERS = 'drawer-filters';
export const SEARCH_PARAM_KEY_DRAWER_SORTER = 'drawer-sorter';
